module.exports = __webpack_public_path__ + "img/back3.3d1f3c1e.png";